import { combineReducers } from "@reduxjs/toolkit";
import utilitySlice from "./slices/utilitySlice";
import AuthenticationSlice from "./authSlice";
import routeFlowSlice from "./routeFLowSlice";
import activeShiftSlice from "./slices/activeShiftSlice";

export default combineReducers({
    utilitySlice,
    AuthenticationSlice,
    routeFlowSlice,
    activeShiftSlice,
});
